import { Badge, IconButton } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import moment from 'moment';
import { UscgSafetyInterface } from '../../../utils/types/uscgSafety';
import { UserInterface } from '../../../utils/types/user';
import { ReactComponent as EditIcon } from '../../../assets/images/edit.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import dayjs from 'dayjs';

const getUscgSafetyGridColumns = (
  onEditUscgSafety: (uscgSafety: UscgSafetyInterface) => void,
  onDeleteUscgSafety: (uscgSafety: UscgSafetyInterface) => void
): Array<MRT_ColumnDef<UscgSafetyInterface>> => [
  {
    accessorKey: 'expiration_date',
    header: 'Expiration date',
    size: 100,
    Cell: ({ cell }) => {
      const date = new Date(cell.getValue<string>());
      const isoString = dayjs(date).toISOString();
      const [year, month, day] = isoString.split('T')[0].split('-');
      const formattedDate = `${day}/${month}/${year}`;

      if (!date) {
        return '--';
      } else {
        return <span style={{ color: '#52659B', fontWeight: 500 }}>{formattedDate}</span>;
      }
    }
  },
  {
    accessorKey: 'state',
    header: 'State',
    size: 100,
    Cell: ({ cell }) => {
      const state = cell.getValue<string>();
      const stateHexaMap: { [key: string]: string } = {
        green: '#4CAF50',
        yellow: '#FFC107',
        red: '#F44336'
      };

      return (
        <Badge
          color="primary"
          badgeContent={''}
          sx={{
            '.MuiBadge-badge': {
              backgroundColor: stateHexaMap[state],
              position: 'relative',
              top: 0,
              left: 0
            }
          }}
        />
      );
    }
  },
  {
    accessorKey: 'title',
    header: 'Title'
  },
  {
    accessorKey: 'additional_information',
    header: 'Additional Information',
    Cell: ({ cell }) => {
      const additionalInformation = cell.getValue<string>();

      return <p style={{ whiteSpace: 'pre-line' }}>{additionalInformation}</p>;
    }
  },
  {
    accessorKey: 'creator',
    header: 'Created by',
    enableSorting: false,
    Cell: ({ cell }) => {
      const creator = cell.getValue<UserInterface>();

      return <span>{creator ? creator.name + ' ' + creator.lastName : '--'}</span>;
    }
  },
  {
    accessorKey: 'updatedAt',
    header: 'Updated at',
    Cell: ({ cell }) => {
      const date = new Date(cell.getValue<string>());
      const humanReadableDate = moment(date).fromNow();

      return <span style={{ color: '#52659B', fontWeight: 500 }}>{humanReadableDate}</span>;
    }
  },
  {
    accessorKey: 'actions',
    header: 'Actions',
    Cell: ({ cell }) => {
      const { row } = cell;

      return (
        <div
          style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}>
          <IconButton
            color="secondary"
            aria-label="Edit"
            onClick={() => onEditUscgSafety(cell.row.original)}>
            <EditIcon />
          </IconButton>

          <IconButton
            color="secondary"
            aria-label="Delete"
            onClick={() => onDeleteUscgSafety(cell.row.original)}>
            <CloseIcon />
          </IconButton>
        </div>
      );
    }
  }
];

export default getUscgSafetyGridColumns;
